"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidSampleCode = void 0;
var InvalidSampleCode;
(function (InvalidSampleCode) {
    InvalidSampleCode[InvalidSampleCode["Other"] = 1] = "Other";
    InvalidSampleCode[InvalidSampleCode["Unable to Collect"] = 2] = "Unable to Collect";
    InvalidSampleCode[InvalidSampleCode["Improper Location"] = 4] = "Improper Location";
})(InvalidSampleCode = exports.InvalidSampleCode || (exports.InvalidSampleCode = {}));
//# sourceMappingURL=InvalidSampleCode.js.map